import type { SVGProps } from 'react'

export const EyeOpened = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 67 32' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M3 24.5C3 24.5 10 3 32.5 3C55 3 63.5 24.5 63.5 24.5'
      strokeWidth='6'
      fill='none'
    />
    <ellipse cx='32.5' cy='21.5' rx='11' ry='10.5' />
  </svg>
)

EyeOpened.toString = () => 'eye-opened'
